import type { Dayjs } from 'dayjs';
import React, { type FC, type ReactElement } from 'react';

import { useAuth } from '~/hooks/useAuth';

import dayjs from '~/dayjs';

const Date: FC<{
  value?: string | Dayjs;
}> = function ({ value }): ReactElement {
  const { user } = useAuth();

  const timezone = user?.timezone ?? 'America/Montreal';
  const format = user?.dateFormat ?? 'LL';

  if (!value) {
    return <span className='Date' />;
  }

  return <span className='Date'>{dayjs.utc(value).tz(timezone).format(format)}</span>;
};

export default Date;
